module.exports = __webpack_public_path__ + "img/Title-EN.08401f94.png";